import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="price-and-tax"
export default class extends Controller {
  static targets = ["buyxgetyfree", "input", "select", "excRadio", "incRadio"];
  connect() {}

  update() {
    const frame = document.getElementById("price-breakdown");
    frame.src = this.getUrl();
    if (this.inputTarget.value) {
      this.buyxgetyfreeTarget.removeAttribute("hidden");
    } else {
      this.buyxgetyfreeTarget.setAttribute("hidden", true);
    }
  }

  attach({ detail: { tax_rate_id } }) {
    const frame = document.getElementById("price-and-tax");
    frame.src = this.getUrl(tax_rate_id);
  }

  getUrl(taxRateId) {
    const url = new URL(window.location.href);

    url.searchParams.set("tax_rate_id", taxRateId || this.selectTarget.value);
    url.searchParams.set("price", this.inputTarget.value);

    if (this.hasExcRadioTarget && this.excRadioTarget.checked) {
      url.searchParams.set("tax_behavior", "exclusive");
    }

    if (this.hasIncRadioTarget && this.incRadioTarget.checked) {
      url.searchParams.set("tax_behavior", "inclusive");
    }

    return url.toString();
  }
}
